import { Navigate, useLocation } from "react-router-dom";
import { useAppSelector } from "../../hook/store";
import { getFlatRoute } from "../routeTool";
import { ESliceAuth } from '../../store/slices/authSlice'
import { ESliceMenu } from '../../store/slices/menuSlice'
import { ERouteKey } from '../../compiler/route.enum';

type TRole = 'super_admin' | 'admin' | 'user'

export interface IRequireAuthProps {
  role: TRole[]
}

function RequireAuth({ children }: { children: JSX.Element }) {
  const storeState = useAppSelector(state => state)
  const user = storeState[ESliceAuth.AuthInfo]
  const menu = storeState[ESliceMenu.menu]

  // console.log('user -> ', user)
  // console.log('menu -> ', menu)

  let location = useLocation()
  let currentPath = location.pathname
  let flatRoute = getFlatRoute()

  // Not Login
  if (!user.company_uuid) {
    console.log('you don\'t have permission to access target url')
    return <Navigate to={'/' + getFlatRoute()[ERouteKey.LOGIN].path} state={{ from: location }} replace />;
  }

  // All permissions are zero → redirect to no-permission page
  const noPermPath = '/' + flatRoute[ERouteKey.NO_PERMISSION]?.path
  const welcomePath = '/' + flatRoute[ERouteKey.WELCOME]?.path
  const allReadZero =
    Array.isArray(user.permission) &&
    user.permission.length > 0 &&
    user.permission.every((p: any) => !p.read || p.read === 0)
  if (allReadZero && currentPath !== noPermPath && currentPath !== welcomePath) {
    return <Navigate to={noPermPath} state={{ from: location }} replace />;
  }

  // Inactive account → redirect to no-permission page with reason
  if (user.is_active === 0 && currentPath !== noPermPath) {
    return <Navigate to={noPermPath} state={{ from: location, reason: 'inactive' }} replace />;
  }

  // Not permission (read) — skip Welcome page (code "00") to avoid redirect loop
  // ไม่มี permission จะไม่ render route อยู่แล้ว (กันเหนียว)
  if (!menu.read && menu.code && menu.code !== '00' && currentPath !== welcomePath) {
    return <Navigate to={'/' + getFlatRoute()[ERouteKey.WELCOME].path} state={{ from: location }} replace />;
  }

  // Already Login
  // In Login Page
  // if (currentPath === flatRoute[ERouteKey.LOGIN].path) {
  //   return <Navigate to={flatRoute[ERouteKey.DASHBOARD].path || '/'} state={{ from: location }} replace />;
  // }
  // In ... Page

  return children;
}


export default RequireAuth
